import { useDigest } from "../api/digest";
import { Loading, ErrorState } from "../components/States";

export function Digest() {
  const digest = useDigest();

  if (digest.isPending) return <Loading />;
  if (digest.isError) return <ErrorState onRetry={() => digest.refetch()} />;
  const d = digest.data;
  if (!d) return <ErrorState message="Couldn't load the digest." />;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-lg font-semibold">Week in review</h1>
        <p className="text-xs text-slate-500">
          {d.week_start} → {d.week_end}
        </p>
      </div>

      <section>
        <h2 className="text-sm font-medium text-slate-300 mb-2">Active alerts</h2>
        {d.active_alerts.length === 0 ? (
          <p className="text-sm text-slate-500">Nothing firing.</p>
        ) : (
          <div className="space-y-2">
            {d.active_alerts.map((a) => (
              <div key={a.config_id} className="rounded-lg border border-amber-700/60 bg-amber-950/30 p-3 text-sm">
                <div className="font-medium text-amber-200">{a.title}</div>
                <div className="text-amber-100/80">{a.detail}</div>
              </div>
            ))}
          </div>
        )}
      </section>

      <section>
        <h2 className="text-sm font-medium text-slate-300 mb-2">New observations this week</h2>
        {d.new_patterns.length === 0 ? (
          <p className="text-sm text-slate-500">No new patterns.</p>
        ) : (
          <div className="rounded-lg border border-slate-800 bg-slate-900/40 px-4">
            {d.new_patterns.map((p) => (
              <div key={p.id} className="border-b border-slate-800 py-2 last:border-b-0 text-sm">
                <span className="text-xs uppercase tracking-wide text-slate-500 mr-2">{p.pattern_type}</span>
                {p.description}
              </div>
            ))}
          </div>
        )}
      </section>

      <section>
        <h2 className="text-sm font-medium text-slate-300 mb-2">Cost report (last 7 days)</h2>
        <dl className="rounded-lg border border-slate-800 bg-slate-900/40 px-4 text-sm">
          <CostRow label="Claude input tokens" value={d.cost.anthropic_input_tokens} />
          <CostRow label="Claude output tokens" value={d.cost.anthropic_output_tokens} />
          <CostRow label="Voyage tokens" value={d.cost.voyage_tokens} />
          <CostRow label="SimpleFIN account pulls" value={d.cost.simplefin_account_pulls} />
        </dl>
        <p className="text-xs text-slate-600 mt-1">Usage is shared across both users.</p>
      </section>
    </div>
  );
}

function CostRow({ label, value }: { label: string; value: number }) {
  return (
    <div className="flex items-center justify-between border-b border-slate-800 py-2 last:border-b-0">
      <dt className="text-slate-400">{label}</dt>
      <dd className="tabular-nums">{value.toLocaleString()}</dd>
    </div>
  );
}
